import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { authentication__impersonate_user, authentication_sign_out } from './actions';

function ImpersonatePage() {
    const dispatch = useDispatch();
    const history = useHistory();
    const isImpersonated = useSelector((state) => state.authenticationReducer.signedIn);
    const userInfo = useSelector((state) => state.authenticationReducer.userInfo);
    const signedIn = useSelector((state) => state.authenticationReducer.signedIn);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const dataStr = params.get('impersonateData');
        if (dataStr) {
            console.log('Impersonate data found');
            const impersonateData = JSON.parse(decodeURIComponent(dataStr));
            console.log('Impersonate data:', impersonateData);
            dispatch(authentication__impersonate_user(impersonateData));
        } else {
            dispatch(authentication_sign_out());
        }
    }, [dispatch]);

    // Navigate only after Redux state is updated
    useEffect(() => {
        if (isImpersonated && userInfo) {
            history.push('/');
        } else if (signedIn === false) {
            history.push('/sign-in');
        }
    }, [isImpersonated, userInfo, signedIn]);

    return null;
}

export default ImpersonatePage;
